import { Box, Button, Typography } from "@mui/material";
import { StyledWorkshops } from "./Workshops.styled";
import workshopImage from "../../Images/atelier.jpg";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { Expo } from "../../Models/Expo";
import { useExpo } from "../../stores/useExpo";
import { useProfile } from "../../stores/useProfile";
import { SERVERURL } from "../../Globals/Constants";
import { ExpoItem } from "../../Components/ExpoItem/ExpoItem";
import { TrashSimpleIcon } from "@phosphor-icons/react";

export const Workshops = () => {
  const navigate = useNavigate();

  const { fetchAllExpos, removeExpo } = useExpo();
  const [expos, setExpos] = useState<Expo[]>([]);
  const { user } = useProfile();

  const updateitems = async () => {
    const res = await fetchAllExpos();
    if (res) setExpos(res.reverse());
  };

  useEffect(() => {
    updateitems();
    // eslint-disable-next-line
  }, []);

  const handleRemove = async (id: number) => {
    if (!user) return;
    const res = await removeExpo(user, id);

    if (res === 200) updateitems();
  };

  const filteredExpos = useMemo(() => {
    return expos.filter((e) => e.title.includes("WORKSHOP"));
  }, [expos]);

  return (
    <StyledWorkshops>
      <Box className="header">
        <Typography variant="h1">Workshops</Typography>
      </Box>
      <Box className="info">
        <Box className="imageWrapper">
          <img src={workshopImage} alt="workshop locatie" />
        </Box>
        <Box className="content">
          <Typography variant="h2">Zin om creatief bezig te zijn?</Typography>
          <Typography variant="body1">
            Tijdens mijn workshops begeleid ik je stap voor stap bij het
            beschilderen van een sculptuur – jouw eigen unieke creatie. Geen
            ervaring nodig: iedereen kan meedoen!
          </Typography>
          <Typography variant="body1">
            Ontspan, laat je inspireren en ontdek nieuwe technieken die je ook thuis kunt gebruiken.
          </Typography>
          <Typography variant="body1">
            Gun jezelf een moment van creativiteit!
          </Typography>
          <Typography variant="body1">
            Wil je graag samen met vrienden, vriendinnen of kennissen deelnemen?
            Je kan ook een workshop op aanvraag boeken voor je eigen groepje. De
            groep bestaat dan uit <b>minimum 4 en maximaal 6 personen</b>.
          </Typography>
          <Button onClick={() => navigate("/contact")}>
            Schrijf je nu in!
          </Button>
        </Box>
      </Box>
      <Box className="workshopWrapper">
        {filteredExpos.reverse().map((expo) => (
          <>
            {expo.files.length > 1 ? (
              <ExpoItem expo={expo} onRemove={updateitems} />
            ) : (
              <Box className="newWorkshop">
                <Typography variant="h2">Volgende workshop</Typography>
                <Box className="workshopItem">
                  {user && (
                    <TrashSimpleIcon
                      size={32}
                      weight="bold"
                      onClick={() => handleRemove(expo.id)}
                    />
                  )}
                  <Box className="image">
                    <img src={`${SERVERURL}${expo.files[0].filePath}`} alt={expo.title}/>
                  </Box>
                  <Box className="content">
                    <Typography variant="h3">
                      {expo.title.replace("WORKSHOP=", "")}
                    </Typography>
                    <Typography variant="h5">{expo.time}</Typography>
                    <Typography variant="h5">{expo.location}</Typography>
                    <br />
                    <Typography
                      variant="h5"
                      dangerouslySetInnerHTML={{ __html: expo.info }}
                    />
                    <br />
                    <Button onClick={() => navigate("/contact")}>
                      Schrijf je in!
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
          </>
        ))}
      </Box>
    </StyledWorkshops>
  );
};
